import type { IconsTypes } from '../ui/icon/icon.types'

export function getIconName(methodId: string): keyof typeof IconsTypes {
    switch (methodId) {
        case 'tbank': {
            return 'card'
        }
        case 'tbank-sbp': {
            return 'sbp'
        }
        case 'sberpay': {
            return 'sberPay'
        }
        case 'wallet-one': {
            return 'walletOne'
        }
        default: {
            return 'card'
        }
    }
}
